import axios from 'axios'
import OSS from 'ali-oss'
import jsonp from 'axios-jsonp'
// 环信IM配置
import websdk from 'easemob-websdk'
import store from "./store";
import config from "./utils/WebIMConfig";
// let uploadUrl = process.env.NODE_ENV === 'production'? '//api.smartservice.bjev.com.cn':'//zhgj.qa.cloudyoung.cn';
let uploadUrl = '//beijing-gateway-bside.app-dev.bjev.com.cn';
if(process.env.NODE_ENV === 'production'){
    uploadUrl = '//beijing-gateway-bside.app-prod.bjev.com.cn';
} else if(location.hostname === 'localhost'){
    // 本地开发
    uploadUrl = '/uploadApi';
}
export default{
    install(Vue, options) {
        /**转换后台返回数据*/
        Vue.prototype.getBase64 = function (img, callback) {
            const reader = new FileReader()
            reader.addEventListener('load', () => callback(reader.result))
            reader.readAsDataURL(img)
        }
        Vue.prototype.$axios = axios;
        Vue.prototype.OSS = OSS;
        Vue.prototype.jsonp = jsonp;
        Vue.prototype.getLocalTime = function(date) {
            function add(val) {
                return val < 10 ? '0' + val : val;
            }
            var now = new Date(date);

            var year=now.getFullYear();
            var month=now.getMonth()+1;
            var date=now.getDate();
            var hour=now.getHours();
            var minute=now.getMinutes();
            var second=now.getSeconds();
            return year+"-"+add(month)+"-"+add(date)+" "+add(hour)+":"+add(minute)+":"+add(second);
            // console.log(new Date(parseInt(now)));
        }

        Vue.prototype.$getProvince = function (callBack) {                   // 获取所有省份
            this.$get("countries/86/provinces").then((data)=>{
                var provinceArr = [];
                for(var i=0;i<data.length;i++){
                    provinceArr.push({
                        name:data[i].name,
                        id:data[i].code
                    })
                }
                callBack(provinceArr)
            });
        }

        Vue.prototype.$getCityByProvince = function (provCode, callBack) {     // 根据省份code查询城市
           if(provCode=='')return
            this.$get("countries/86/provinces/"+provCode+"/cities", ).then((data)=>{
                var provinceArr = [];
                for(var i=0;i<data.length;i++){
                    provinceArr.push({
                        name:data[i].name,
                        id:data[i].code
                    })
                }
                callBack(provinceArr);
            });
        }

        Vue.prototype.$getCountyByCity = function (cityCode, callBack) {           // 根据城市code查询地区
            if(cityCode=='')return
            this.$get("countries/86/provinces/cities/"+cityCode+"/areas").then((data)=>{
                var provinceArr = [];
                for(var i=0;i<data.length;i++){
                    provinceArr.push({
                        name:data[i].name,
                        id:data[i].code
                    })
                }
                callBack(provinceArr);
            });
        }


        Vue.prototype.$upLoadFile = function (option) {
            this.$axios({
                // 上传oss接口，获取签名的一些信息，后面可以在加&name=设置路径名称
                url: uploadUrl+'/beijing-saas-alicloud/interior/v1/aliyun/oss/params',
                callbackParamName:'ossCB' // optional, 'callback' by default
            }).then((res) => {
                ossCB(res)
            });
            let ossCB = (data) =>{
                let res = data.data
                var form = {
                    region: 'oss-cn-beijing',
                    accessKeyId:res.AccessKeyId,
                    accessKeySecret: res.AccessKeySecret,
                    stsToken: res.SecurityToken,
                    bucket: res.bucket,
                    authorizationV4: true, // 从V1签名升级为V4签名
                };
                var client = new this.OSS(form)
                var aliyunFileKey= res.aliyunFileKey;
                console.log('aliyunFileKey=====>',aliyunFileKey)
                var progress = async function progress(p, checkpoint) {
                    // console.log(p,checkpoint)
                };
                return client.multipartUpload(aliyunFileKey, option.file,{progress:progress}).then(function (result) {
                  // 图片存储cdn域名
                    option.success('https://cdn.smartservice.bjev.com.cn/'+aliyunFileKey)
                }).catch(function (err) {
                    console.log(err);
                });
            };
        }

        Vue.prototype.regex = {
            storeName:{
                rule:/^[a-zA-Z\u4e00-\u9fa5]{1,80}$/,
                err:'只能输入汉字，英文，最多80个字符，'
            },
            storeCode:{
                rule:/^[a-zA-Z\0-9]{1,50}$/,
                err:'只能输入数字，字母，最多50个字符'
            },
            name:{
                rule:/^[a-zA-Z\u4e00-\u9fa5\0-9]{1,20}$/,
                err:'只能输入汉字，英文，数字，最多20个字符'
            },
            mobile:{
                rule:/(^(1[0-9])\d{9}$)/,
                err:'手机号码格式错误'
            },
            telephone:{
                rule:/^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/,
                err:'固话格式错误'
            },
            storeRangeCode:{
                rule:/^(0|([1-9]\d{0,2}))$/,
                err:'请输入0～999之间数字'
            }
        };

        Vue.prototype.authCheck = function(code){
            return this.$store.getters.permission.includes(code);
        }
        // let WebIM = window.WebIM = websdk

        // var WebIM = {};
        // WebIM = window.WebIM = websdk;
        // WebIM.config = config;

        // Vue.prototype.$WebIM = WebIM;


        // Vue.prototype.$imConn = new WebIM.connection({
        //     appKey: WebIM.config.appkey,
        //     isHttpDNS: WebIM.config.isHttpDNS,
        //     isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
        //     https: WebIM.config.https,
        //     url: WebIM.config.xmppURL,
        //     apiUrl: WebIM.config.apiURL,
        //     isAutoLogin: true,
        //     heartBeatWait: WebIM.config.heartBeatWait,
        //     autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
        //     autoReconnectInterval: WebIM.config.autoReconnectInterval,
        //     isStropheLog: WebIM.config.isStropheLog,
        //     delivery: WebIM.config.delivery
        // });
        // // console.log("Vue.prototype.$imConn.apiUrl",Vue.prototype.$imConn.apiUrl)
        // console.log(1111)
        // if (!Vue.prototype.$imConn.apiUrl) {
        //     Vue.prototype.$imConn.apiUrl = WebIM.config.apiURL;
        // }

        // Vue.prototype.$imoption = {
        //     apiUrl: websdk.config.apiURL,
        //     user: '',
        //     pwd: '',
        //     appKey: websdk.config.appkey,
        //     success:function (token) {
        //         console.log('%c 登陆成功', 'color: green')
        //         console.log(token)
        //     },
        //     error:function (err) {
        //         console.log('%c *** err ***', 'color: red')
        //         console.log(err)
        //     }
        // }

        Vue.directive('paste',{
            bind(el,binding,vnode) {
                el.addEventListener('paste',function(event){ //这里直接监听元素的粘贴事件
                    binding.value(event)
                })
            }
        })

        // Vue.prototype.$imConn = conn
        // Vue.prototype.$imoption = options

    }
}

